(() => {
  'use strict';

  const documentLanguage = String(document.documentElement.lang || '').toLowerCase();
  if (!documentLanguage.startsWith('ar')) return;

  const ENGLISH_PREFIX = /^\/en(?=\/|$)/i;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('data-no-locale-guard')) return;
    if (link.closest('m-localization-form, .m-language-switcher, [data-localization-form]')) return;
    if (link.target && link.target !== '_self') return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin || !ENGLISH_PREFIX.test(url.pathname)) return;

    const arabicPath = url.pathname.replace(ENGLISH_PREFIX, '') || '/';
    url.pathname = arabicPath;
    event.preventDefault();
    window.location.assign(url.href);
  }, true);
})();